import { observable, action, autorun } from 'mobx';
import { notification } from 'antd';
import { persist } from 'mobx-persist';
import { request } from '~/utils/';

class State {
  @persist
  @observable
  accessToken = '';

  @persist('map')
  @observable
  streams = new Map();

  @persist('map')
  @observable
  details = new Map();

  constructor(root) {
    this.root = root;

    autorun(() => {
      console.log('#token', this.accessToken);
    });
  }

  @action
  setToken = async accessToken => {
    this.accessToken = accessToken;
  };

  @action
  clearToken = async () => {
    const lives = this.details.values();
    let avaiable = true;

    console.log(this.details);
    lives.forEach(l => {
      console.log(l);
      const { status } = l;
      if (status === 0 || status === 1) {
        avaiable = false;
      }
    });

    if (!avaiable) {
      notification.open({
        message: '注销登录',
        description: '存在未结束/未开始直播，请结束或删除后再次注销。',
      });
      return;
    }

    this.accessToken = '';
    this.streams.clear();
    this.details.clear();
  };

  @action
  create = async (options, opts) => {
    const access_token = this.accessToken;
    const is_panolive = '1';
    try {
      const { data } = await request.post('api/weibo/live/create', {
        access_token,
        is_panolive,
        ...options,
      });
      const { id } = data;
      this.streams.set(id, {
        ...data,
      });

      // 获取详情
      await this.show(id);

      opts.success && opts.success();
    } catch ({ response }) {
      const { data } = response;
      const desc = (data && data.error) || '';
      notification.open({
        message: '创建失败',
        description: desc,
      });

      opts.fail && opts.fail();
    }
  };

  @action
  update = async options => {
    const access_token = this.accessToken;
    try {
      const { data } = await request.post('api/weibo/live/update', {
        access_token,
        ...options,
      });
      if (data.id) {
        const { id } = options;
        const stream = this.streams.get(id);
        this.streams.set(id, {
          ...stream,
        });
        await this.show(id);
      }
    } catch ({ response }) {
      const { data, status } = response;
      console.log(status);
      if (status === 403) {
        notification.open({
          message: '更新失败',
          description: '授权已过期，请删除该直播并注销账号后重新创建。',
        });
        return;
      }

      const desc = (data && data.error) || '';
      notification.open({
        message: '更新失败',
        description: desc,
      });
    }
  };

  @action
  remove = async id => {
    const access_token = this.accessToken;
    try {
      await request.post('api/weibo/live/delete', {
        access_token,
        id,
      });
    } catch (error) {
      console.log(error);
    } finally {
      this.streams.delete(id);
      this.details.delete(id);
    }
  };

  @action
  show = async id => {
    const access_token = this.accessToken;
    try {
      const { data } = await request.post('api/weibo/live/show', {
        access_token,
        id,
        detail: '1',
      });
      this.details.set(id, data);
    } catch (error) {
      console.log(error);
      const { response } = error;
      const { data } = response;
      const desc = (data && data.error) || '';
      notification.open({
        message: '查询失败',
        description: desc,
      });
    }
  };
}

export default State;



// WEBPACK FOOTER //
// ./src/store/weibo.js